module.exports = __webpack_public_path__ + "static/media/photo-1519861410433-7f9e2b469cca.48d6480e.jfif";